import React from 'react';
import PropTypes from 'prop-types';

import Menu from "./Menu";
import AdvertDetail from "../AdvertDetail";
import Formsy from 'formsy-react';
import Loading from "components/Loading";
import {getStatusFromError} from "helpers/errors";
import InputFormGroup from "components/Form/InputFormGroup";
import TagInputFormGroup from "components/Form/TagInputFormGroup";
import PhotoInputFormGroup from "components/Form/PhotoInputFormGroup";
import SelectFormGroup from "components/Form/SelectFormGroup";
import {Button, Row, Col, Alert, FormGroup, Label} from 'reactstrap';
import {defineMessages, FormattedMessage, injectIntl} from "react-intl";
import IconSvg from "../IconSvg";
import moment from 'moment';

const messages = defineMessages({
    mon: {
        id: "day.monday",
        defaultMessage: "Monday",
    },
    tue: {
        id: "day.tuesday",
        defaultMessage: "Tuesday",
    },
    wed: {
        id: "day.wednesday",
        defaultMessage: "Wednesday",
    },
    thu: {
        id: "day.thursday",
        defaultMessage: "Thursday",
    },
    fri: {
        id: "day.friday",
        defaultMessage: "Friday",
    },
    sat: {
        id: "day.saturday",
        defaultMessage: "Saturday",
    },
    sun: {
        id: "day.sunday",
        defaultMessage: "Sunday",
    },
});

class AdvertForm extends React.Component {
    static propTypes = {
        onAdvertFormSubmit: PropTypes.func.isRequired,
        advert: PropTypes.object,
        serviceTypeValues: PropTypes.array.isRequired,
        priceValuesVoice: PropTypes.array.isRequired,
        priceValuesSms: PropTypes.array.isRequired,
        showPreview: PropTypes.bool,
        canHaveHappyHours: PropTypes.bool,
        intl: PropTypes.object.isRequired,
    };

    static advertFields = ['name', 'title', 'text', 'serviceTypes', 'photoUrl'];
    static pricelistFields = ['callPrice', 'smsPrice'];

    componentWillMount() {
        this.initState(this.props);
    }

    componentWillReceiveProps(newProps) {
        if (this.props.advert !== newProps.advert) {
            this.initState(newProps);
        }
    }

    initState(props) {
        const model = props.advert ? props.advert : {
            photoUrl: '',
            name: '',
            title: '',
            text: '',
            serviceTypes: [],
        };

        this.setState({
            page: 'advert',
            model,
            valid: false,
            happyHours: props.advert ? props.advert.adHappyHours.slice(0) : [],
        });
    }

    addHappyHour() {
        const happyHours = this.state.happyHours.slice(0);
        happyHours.push({id: moment().unix(), hourFrom: '8', hourTo: '9', dayOfWeek: '0'});
        this.setState({
            happyHours
        });
    }

    removeHappyHour(idx) {
        const happyHours = this.state.happyHours.slice(0);
        happyHours.splice(idx, 1);
        this.setState({
            happyHours
        });
    }

    onFormChange(model) {
        this.setState({
            model,
        });

        for (const prop in model) {
            if (/^happyHour-\d+-(from)$/.test(prop)) {
                const idx = prop.match(/\d+/)[0];
                const hourFrom = model['happyHour-' + idx + '-from'];
                const hourTo = model['happyHour-' + idx + '-to'];

                if (parseInt(hourFrom, 10) >= parseInt(hourTo, 10)) {
                    const input = this.form.inputs.find(input => (input.props.name === ('happyHour-' + idx + '-to')));
                    input.setValue(parseInt(hourFrom, 10) + 1);
                }
            }
        }
    }

    onSubmit(model) {
        this.setState({
            loading: true,
        });
        const processedModel = Object.assign({happyHours: []}, model);

        for (const prop in model) {
            if (/^happyHour-\d+-(from)$/.test(prop)) {
                const idx = prop.match(/\d+/)[0];
                processedModel.happyHours.push({
                    dayOfWeek: parseInt(model['happyHour-' + idx + '-day'], 10),
                    hourFrom: parseInt(model['happyHour-' + idx + '-from'], 10),
                    hourTo: parseInt(model['happyHour-' + idx + '-to'], 10),
                });

                delete processedModel['happyHour-' + idx + '-day'];
                delete processedModel['happyHour-' + idx + '-from'];
                delete processedModel['happyHour-' + idx + '-to'];
            }
        }

        processedModel.serviceTypes = model.serviceTypes.map(type => (type.value));

        this.props.onAdvertFormSubmit(processedModel).then(() => {
            this.setState({
                loading: false,
            });
        }).catch(e => {
            this.setState({
                loading: false,
                status: getStatusFromError(e),
            });
        });
    }

    render() {
        const {advert, serviceTypeValues, priceValuesVoice, priceValuesSms, showPreview, canHaveHappyHours, intl} = this.props;
        const {status, loading, valid} = this.state;
        const {page} = this.state;

        const defaultValues = advert;
        const advertPageError = this.form && this.form.inputs.some(
            input => (AdvertForm.advertFields.includes(input.props.name) && (input.showError() || input.showRequired()))
        );

        const pricelistPageError = this.form && this.form.inputs.some(
            input => (AdvertForm.pricelistFields.includes(input.props.name) && (input.showError() || input.showRequired()))
        );

        const happyHourFromOptions = Array.from(Array(24)).map((_, num) => ({
            name: num.toString(10) + ':00',
            value: num.toString(10)
        }));

        const happyHourToOptions = Array.from(Array(24)).map((_, num) => ({
            name: (num + 1).toString(10) + ':00',
            value: (num + 1).toString(10)
        }));

        const happyHourDayOfWeekOptions = [
            {
                name: intl.formatMessage(messages.mon),
                value: '0',
            },
            {
                name: intl.formatMessage(messages.tue),
                value: '1',
            },
            {
                name: intl.formatMessage(messages.wed),
                value: '2',
            },
            {
                name: intl.formatMessage(messages.thu),
                value: '3',
            },
            {
                name: intl.formatMessage(messages.fri),
                value: '4',
            },
            {
                name: intl.formatMessage(messages.sat),
                value: '5',
            },
            {
                name: intl.formatMessage(messages.sun),
                value: '6',
            },

        ];

        return (
            <div>
                <Menu activePage={page} showAdvertError={advertPageError} showPricelistError={pricelistPageError}
                      onPageChange={(page) => this.setState({page})}/>

                <Formsy onValidSubmit={::this.onSubmit} onValid={() => this.setState({valid: true})}
                        onInvalid={() => this.setState({valid: false})} onChange={::this.onFormChange}
                        ref={r => this.form = r}
                >
                    <Row className={"mt-4" + (page !== 'advert' ? ' d-none' : '')}>
                        <Col md={showPreview ? 6 : undefined}>
                            <InputFormGroup
                                label={(<FormattedMessage id="advert.new.name_label"
                                                          defaultMessage="Name (nickname)"/>)}
                                value={defaultValues ? defaultValues.name : ''}
                                name="name"
                                id="name"
                                type="text"
                                required
                            />
                            <TagInputFormGroup
                                label={(<FormattedMessage id="advert.new.service_types_label"
                                                          defaultMessage="Service types"/>)}
                                value={defaultValues ? defaultValues.serviceTypes.map(type => ({
                                    value: type.key,
                                    name: type.name
                                })) : []}
                                name="serviceTypes"
                                id="serviceTypes"
                                values={serviceTypeValues}
                                required="notEmptyArray"
                            />
                            <InputFormGroup
                                label={(<FormattedMessage id="advert.new.title_label" defaultMessage="Title"/>)}
                                value={defaultValues ? defaultValues.title : ''}
                                name="title"
                                id="title"
                                type="text"
                                required
                                characterLimit={60}
                                validations="maxLength:60"
                                validationErrors={{
                                    maxLength: (<FormattedMessage id="form.error.max_length"
                                                                  defaultMessage="Maximum length of {length, plural, one {# character} other {# characters}} exceeded"
                                                                  values={{length: 60}}/>)
                                }}
                            />
                            <InputFormGroup
                                label={(<FormattedMessage id="advert.new.text_label" defaultMessage="Text"/>)}
                                value={defaultValues ? defaultValues.text : ''}
                                name="text"
                                id="text"
                                type="textarea"
                                required
                                characterLimit={140}
                                validations="maxLength:140"
                                validationErrors={{
                                    maxLength: (<FormattedMessage id="form.error.max_length"
                                                                  defaultMessage="Maximum length of {length, plural, one {# character} other {# characters}} exceeded"
                                                                  values={{length: 140}}/>)
                                }}
                            />
                            <PhotoInputFormGroup
                                value={(defaultValues && defaultValues.photoUrl) ? defaultValues.photoUrl : ''}
                                name="photoUrl"
                                id="photoUrl"
                                validTypes={['image/jpeg', 'image/png']}
                                sizeLimit={4194304}
                                showSuccess={!showPreview}
                            />

                            {status &&
                            <Alert color={status.type}>
                                {status.message}
                            </Alert>
                            }

                            {(advertPageError || pricelistPageError) &&
                            <Alert color="danger">
                                <FormattedMessage id="form.error.fill_all_fields"
                                                  defaultMessage="Please fill in all the required fields"/>
                            </Alert>
                            }

                            {pricelistPageError &&
                            <Button onClick={() => this.setState({page: 'pricelist'})} color="secondary" block
                                    disabled={advertPageError}>
                                <FormattedMessage id="advert.continue" defaultMessage="Continue"/>
                            </Button>
                            }

                            {!pricelistPageError &&
                            <Button type="submit" color="secondary" block
                                    disabled={!valid || loading}>
                                {loading &&
                                <Loading inline small/>
                                }
                                <FormattedMessage id="advert.save" defaultMessage="Save"/>
                            </Button>
                            }
                        </Col>
                        {showPreview &&
                        <Col md={6} className="mt-3 mt-md-0">
                            <AdvertDetail advert={this.state.model}/>

                            {advert &&
                            <div className="mt-4 mb-3">
                                <FormattedMessage id="advert_modal.assigned_number_title"
                                                  defaultMessage="Assigned number"/>:
                                {advert.publicNumbers.map((number, idx) => (
                                    <div key={'publicNumber-' + idx} className="border-bottom py-2">
                                        <strong className="text-md">{number}</strong>
                                    </div>
                                ))}
                            </div>
                            }
                        </Col>
                        }
                    </Row>

                    <div className={page !== 'pricelist' ? 'd-none' : ''}>
                        <h5 className="text-center mt-4">
                            <FormattedMessage id="advert_modal.default_price.title" defaultMessage="Default price"/>
                        </h5>
                        <Row className="form-row">
                            <Col>
                                <SelectFormGroup
                                    label={(
                                        <FormattedMessage id="advert.new.call_price_label"
                                                          defaultMessage="Call price (per minute)"/>)}
                                    value={defaultValues ? defaultValues.priceLevelVoice.id : ''}
                                    name="callPrice"
                                    id="callPrice"
                                    required
                                    values={priceValuesVoice}
                                />
                            </Col>
                            <Col>
                                <SelectFormGroup
                                    label={(<FormattedMessage id="advert.new.sms_price_label"
                                                              defaultMessage="SMS price"/>)}
                                    value={defaultValues && defaultValues.priceLevelText ? defaultValues.priceLevelText.id : ''}
                                    name="smsPrice"
                                    id="smsPrice"
                                    values={priceValuesSms}
                                />
                            </Col>
                        </Row>

                        {canHaveHappyHours &&
                        <div>
                            <h5 className="text-center mt-4">
                                <FormattedMessage id="advert_modal.happy_hour.title"
                                                  defaultMessage="Happy hour settings"/>
                            </h5>

                            {this.state.happyHours.map((happyHour, idx) => (
                                <Row key={"happyHour-" + happyHour.id} className="form-row happy-hour-row">
                                    <Col>
                                        <SelectFormGroup
                                            label={(
                                                <FormattedMessage id="advert.new.happy_hour_day_of_week_label"
                                                                  defaultMessage="Day of week"/>)}
                                            value={happyHour.dayOfWeek}
                                            name={"happyHour-" + happyHour.id + '-day'}
                                            id={"happyHour-" + happyHour.id + '-day'}
                                            values={happyHourDayOfWeekOptions}
                                        />
                                    </Col>
                                    <Col>
                                        <SelectFormGroup
                                            label={(
                                                <FormattedMessage id="advert.new.happy_hour_from_label"
                                                                  defaultMessage="From"/>)}
                                            value={happyHour.hourFrom}
                                            name={"happyHour-" + happyHour.id + '-from'}
                                            id={"happyHour-" + happyHour.id + '-from'}
                                            values={happyHourFromOptions}
                                        />
                                    </Col>
                                    <Col>
                                        <SelectFormGroup
                                            label={(<FormattedMessage id="advert.new.happy_hour_to_label"
                                                                      defaultMessage="To"/>)}
                                            value={happyHour.hourTo}
                                            name={"happyHour-" + happyHour.id + '-to'}
                                            id={"happyHour-" + happyHour.id + '-to'}
                                            values={happyHourToOptions}
                                        />
                                    </Col>
                                    <Col className="happy-hour-remove-col">
                                        <FormGroup>
                                            <Label>&nbsp;</Label>
                                            <a onClick={() => this.removeHappyHour(idx)} className="remove">
                                                <IconSvg id='remove'/>
                                            </a>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            ))}

                            <div className="mb-3">
                                <a tabIndex={20} className="clickable" onClick={::this.addHappyHour}>
                                    <FormattedMessage id="advert.new.add_happy_hour_range"
                                                      defaultMessage="Add additional happy hour range"/>
                                </a>
                            </div>
                        </div>
                        }

                        {status &&
                        <Alert color={status.type}>
                            {status.message}
                        </Alert>
                        }

                        {(advertPageError || pricelistPageError) &&
                        <Alert color="danger">
                            <FormattedMessage id="form.error.fill_all_fields"
                                              defaultMessage="Please fill in all the required fields"/>
                        </Alert>
                        }

                        {advertPageError &&
                        <Button onClick={() => this.setState({page: 'advert'})} color="secondary" block
                                disabled={pricelistPageError}>
                            <FormattedMessage id="advert.continue" defaultMessage="Continue"/>
                        </Button>
                        }

                        {!advertPageError &&
                        <Button type="submit" color="secondary" block
                                disabled={!valid || loading}>
                            {loading &&
                            <Loading inline small/>
                            }
                            <FormattedMessage id="advert.save" defaultMessage="Save"/>
                        </Button>
                        }
                    </div>
                </Formsy>
            </div>
        )
    }
}

export default injectIntl(AdvertForm)


// WEBPACK FOOTER //
// ./src/components/AdvertForm/AdvertForm.jsx